import {Link} from 'react-router-dom';
import {SearchX} from 'lucide-react';
import EmptyState from './components/utility/EmptyState';
import {RoutePaths} from './RoutePaths';

const PageNotFound = () => (
    <EmptyState
        icon={SearchX}
        title="Page not found"
        action={
            <Link to={RoutePaths.home()} className="btn btn-primary">
                Go to the family tree
            </Link>
        }
    >
        <p className="mb-0">That page does not exist, or has moved.</p>
    </EmptyState>
);

export default PageNotFound;
